// doctor-dashboard/src/hooks/usePushNotifications.js
'use client';
import { useEffect } from 'react';
import { getMessaging, getToken } from 'firebase/messaging';
import { messaging } from '../lib/firebase';
import { registerDeviceToken } from '../api/doctorService';

export const usePushNotifications = (user) => {
    useEffect(() => {
        const initializePush = async () => {
            if (!user || typeof window === 'undefined' || !('Notification' in window) || !('serviceWorker' in navigator)) {
                 
                return;
            }

             if (!messaging) {
                 return;
             }

            const VAPID_KEY = import.meta.env.VITE_VAPID_KEY;

            if (!VAPID_KEY) {
                return;
            }

            try {
                const registration = await navigator.serviceWorker.ready;
                if (Notification.permission === 'granted') {
                    const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration }); // Pass registration
                    if (currentToken) {
                        await registerDeviceToken(currentToken);
                    } else {
                        await requestPermission(messaging, VAPID_KEY, registration); // Pass registration
                    }
                } else if (Notification.permission === 'default') {
                    await requestPermission(messaging, VAPID_KEY, registration); // Pass registration
                } else {

                }
            } catch (err) {
                console.error('usePushNotifications: Error during push initialization.', err); // Log 9
            }
        };

        const requestPermission = async (messaging, vapidKey, registration) => { // Accept registration

            try {
                const permission = await Notification.requestPermission();
                if (permission === 'granted') {
                    const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration });
                    await registerDeviceToken(token);
                }
            } catch (err) {
                console.error('usePushNotifications: Error requesting permission.', err); // Log 12
            }
        };

        if (user) {
            initializePush();
        } else {
        }

    }, [user]);
};